export const API_OPTIONS = {
  method: "GET",
  headers: {
    accept: "application/json",
    Authorization:
      "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJkZjhhMWNmNjMzYWEwNWVmNjI0ZDYzMzFmNmRlODU0MyIsInN1YiI6IjY0ZDYwYzllZGI0ZWQ2MDBmZmI3YjE5OCIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.IXpeVfhCzZpoTsYngzvYww0g0ZIxuSjA-tDekewk9FA",
  },
};

export const IMG_CDN_URL = "https://image.tmdb.org/t/p/w500/";

export const OPENAI_API_KEY = "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";

export const SERVER_URL = "https://hotstar-5dl1.onrender.com";
